import Excel from 'exceljs'
import { saveAs } from 'file-saver'
import _ from 'lodash'

interface ExportInterface {
  branchName: string
  dateStart: string
  dateEnd: string
  receiptPrefix: string
  doctorsFilter: string
  labGroupName: string
  labCompanyName: string
  includeSn: boolean
  data: any
  doctors: any[]
  t: any
}

export const ExportClinicFeeDentistDcc = async (rpt: ExportInterface) => {
  const wb = new Excel.Workbook()
  const ws = wb.addWorksheet(rpt.t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC'), {
    pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1 }
  })

  // Title
  ws.getCell(1, 1).value = rpt.t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC')
  ws.getCell(1, 1).font = { bold: true, size: 14 }
  ws.mergeCells(1, 1, 1, 21)

  // Filter info
  ws.getCell(2, 1).value = `${rpt.t('REPORT.FILTER.BRANCH')}: ${rpt.branchName}`
  ws.getCell(3, 1).value = `${rpt.t('วันที่เริ่ม')}: ${rpt.dateStart || '-'} ถึง: ${rpt.dateEnd || '-'}`
  ws.getCell(4, 1).value = `${rpt.t('REPORT.FILTER.RECEIPT_TYPE')}: ${rpt.receiptPrefix}`
  ws.getCell(5, 1).value = `${rpt.t('USER_DOCTOR')}: ${rpt.doctorsFilter}`
  ws.getCell(6, 1).value = `${rpt.t('REPORT.FILTER.LAB_GROUP')}: ${rpt.labGroupName}`
  ws.getCell(7, 1).value = `${rpt.t('REPORT.FILTER.LAB_COMPANY')}: ${rpt.labCompanyName}`

  // DCC Report Headers
  const headers = [
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.NO'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.BILL_NO'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.DOCTOR'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.PATIENT_CODE'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.PATIENT_NAME'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.REMARK_DISCOUNT'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.TX'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.CF'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.DF'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.MED'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.PD'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.MAT'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.ST'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.XRAY'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.AMOUNT_PAID'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.CASH'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.TRANSFER'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.DEBIT'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.CREDIT_PERCENT'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.CREDIT'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.TREATMENT_RIGHT'),
    rpt.t('REPORT.TABLE.REMUNERATION_DCC.ADVANCE')
  ]

  const headerRow = 9
  headers.forEach((header, index) => {
    const cell = ws.getCell(headerRow, index + 1)
    cell.value = header
    cell.font = { bold: true }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }
    }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
  })

  // Data rows
  let currentRow = headerRow + 1
  const rawRows = rpt.data?.rawRows || []

  rawRows.forEach((row: any, index: number) => {
    const doctorName = _.get(_.find(rpt.doctors, { dentistId: Number(row.doctorId) }), 'dentistFullname') || '-'
    const rowData = [
      index + 1,
      row.billNo || '-',
      doctorName,
      row.branchCnNumber || row.CnNumber || '-',
      row.patientFullname || '-',
      row.remarkDiscount || '-',
      row.paidTx || 0,
      row.cfPaid || 0,
      row.dfPaid || 0,
      row.paidMed || 0,
      row.paidPd || 0,
      row.paidMat || 0,
      row.paidSt || 0,
      row.paidXray || 0,
      row.amountPaid || 0,
      row.amountCash || 0,
      row.amountTransfer || 0,
      row.amountDebit || 0,
      row.creditCost || 0,
      row.amountCredit || 0,
      row.amountTreatmentRight || 0,
      row.amountAdvance || 0
    ]

    rowData.forEach((value, colIndex) => {
      const cell = ws.getCell(currentRow, colIndex + 1)
      cell.value = value
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
      if (colIndex >= 6) {
        cell.numFmt = '#,##0.00'
        cell.alignment = { horizontal: 'right' }
      }
    })
    currentRow++
  })

  // Summary row
  const summaryRow = currentRow
  ws.getCell(summaryRow, 1).value = rpt.t('REPORT.TITLE.SUM')
  ws.mergeCells(summaryRow, 1, summaryRow, 6)
  ws.getCell(summaryRow, 1).font = { bold: true }
  ws.getCell(summaryRow, 1).alignment = { horizontal: 'right' }

  const sumValues = [
    _.sumBy(rawRows, 'paidTx'),
    _.sumBy(rawRows, 'cfPaid'),
    _.sumBy(rawRows, 'dfPaid'),
    _.sumBy(rawRows, 'paidMed'),
    _.sumBy(rawRows, 'paidPd'),
    _.sumBy(rawRows, 'paidMat'),
    _.sumBy(rawRows, 'paidSt'),
    _.sumBy(rawRows, 'paidXray'),
    _.sumBy(rawRows, 'amountPaid'),
    _.sumBy(rawRows, 'amountCash'),
    _.sumBy(rawRows, 'amountTransfer'),
    _.sumBy(rawRows, 'amountDebit'),
    _.sumBy(rawRows, 'creditCost'),
    _.sumBy(rawRows, 'amountCredit'),
    _.sumBy(rawRows, 'amountTreatmentRight'),
    _.sumBy(rawRows, 'amountAdvance')
  ]

  sumValues.forEach((value, index) => {
    const cell = ws.getCell(summaryRow, index + 7)
    cell.value = value
    cell.font = { bold: true }
    cell.numFmt = '#,##0.00'
    cell.alignment = { horizontal: 'right' }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    }
  })

  currentRow = summaryRow + 3

  // Section 1: Dentist Fee Summary
  if (rpt.data?.rowDf && rpt.data.rowDf.length > 0) {
    ws.getCell(currentRow, 1).value = rpt.t('REPORT.TITLE.DENTIST_FEE_SUMMARY')
    ws.getCell(currentRow, 1).font = { bold: true, size: 12 }
    currentRow++

    const dfHeaders = [
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.NO'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DOCTOR'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.NEW_PATIENT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.EXISTING_PATIENT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.TOTAL_TREATMENT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.HAND_INSURANCE'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.TOTAL_PAID'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.CF'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DF'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.CREDIT_PERCENT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DF_TREATMENT_RIGHT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.TOTAL_DF'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.LAB_FEE'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DF_LAB_FEE'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.NET_DF')
    ]

    dfHeaders.forEach((header, index) => {
      const cell = ws.getCell(currentRow, index + 1)
      cell.value = header
      cell.font = { bold: true }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE0E0E0' }
      }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    })
    currentRow++

    rpt.data.rowDf.forEach((row: any, index: number) => {
      const doctorName = _.get(_.find(rpt.doctors, { dentistId: Number(row.doctorId) }), 'dentistFullname') || '-'
      const rowData = [
        index + 1,
        doctorName,
        row.newPatientCount || 0,
        row.existingPatientCount || 0,
        row.totalAmount || 0,
        row.handInsurance || 0,
        row.amountPaid || 0,
        row.amountCf || 0,
        row.amountDf || 0,
        row.dfCredit || 0,
        row.dfLostTreatment || 0,
        row.dfLostCreditAndTreatment || 0,
        row.dfLabFee || 0,
        row.dfLabFee || 0,
        row.dfNet || 0
      ]

      rowData.forEach((value, colIndex) => {
        const cell = ws.getCell(currentRow, colIndex + 1)
        cell.value = value
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
        if (colIndex >= 2) {
          // new / existing patient = จำนวนเคส ใช้เลขจำนวนเต็ม
          if (colIndex === 2 || colIndex === 3) {
            cell.numFmt = '#,##0'
          } else {
            cell.numFmt = '#,##0.00'
          }
          cell.alignment = { horizontal: 'right' }
        }
      })
      currentRow++
    })
    currentRow += 2
  }

  // Section 2: Income / Net Clinic Summary
  if (rpt.data?.summaryIncome) {
    ws.getCell(currentRow, 1).value = rpt.t('REPORT.TITLE.INCOME_SUMMARY')
    ws.getCell(currentRow, 1).font = { bold: true, size: 12 }
    currentRow++

    const incomeHeaders = [
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.INCOME'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.NET_CLINIC'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.NET_DF'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DENTIST_FEE'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DF_LAB'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.CASH'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.TRANSFER'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.DEBIT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.CREDIT_PERCENT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.CREDIT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.TREATMENT_RIGHT'),
      rpt.t('REPORT.TABLE.REMUNERATION_DCC.ADVANCE')
    ]

    incomeHeaders.forEach((header, index) => {
      const cell = ws.getCell(currentRow, index + 1)
      cell.value = header
      cell.font = { bold: true }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE0E0E0' }
      }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    })
    currentRow++

    const summary = rpt.data.summaryIncome
    const incomeData = [
      summary.income || 0,
      summary.netClinic || 0,
      summary.netDf || 0,
      summary.dentistFee || 0,
      summary.dfLab || 0,
      summary.amountCash || 0,
      summary.amountTransfer || 0,
      summary.amountDebit || 0,
      summary.creditCost || 0,
      summary.amountCredit || 0,
      summary.amountTreatmentRight || 0,
      summary.amountAdvance || 0
    ]

    incomeData.forEach((value, index) => {
      const cell = ws.getCell(currentRow, index + 1)
      cell.value = value
      cell.numFmt = '#,##0.00'
      cell.alignment = { horizontal: 'right' }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    })
  }

  // Set column widths
  ws.columns = [
    { width: 8 },   // No
    { width: 15 },  // Bill No
    { width: 20 },  // Doctor
    { width: 15 },  // CN Number
    { width: 20 },  // Patient Name
    { width: 25 },  // Remark/Discount
    { width: 12 },  // Tx
    { width: 12 },  // CF
    { width: 12 },  // DF
    { width: 12 },  // Med
    { width: 12 },  // Pd
    { width: 12 },  // Mat
    { width: 12 },  // ST
    { width: 12 },  // Xray
    { width: 12 },  // Amount Paid
    { width: 12 },  // Cash
    { width: 12 },  // Transfer
    { width: 12 },  // Debit
    { width: 10 },  // Credit %
    { width: 12 },  // Credit
    { width: 12 },  // Treatment Right
    { width: 12 }   // Advance
  ]

  // Save file
  const buffer = await wb.xlsx.writeBuffer()
  saveAs(
    new Blob([buffer]),
    `${rpt.t('REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST_DCC')} (${rpt.dateStart}-${rpt.dateEnd}).xlsx`
  )
}
